import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware';
import create from 'zustand';

import chat from 'lib/api/chat';

interface State {
  count: number;
  hasNewMessage: boolean;
  isReset: boolean;
}

interface Actions {
  fetchUnreadCount(): Promise<void>;
  resetCounter(): void;
}

const initialState: State = {
  count: 0,
  hasNewMessage: false,
  isReset: false,
};

export const useGetChatUnreadCount = create<State & Actions>()(
  persist(
    immer((set) => ({
      ...initialState,
      resetCounter() {
        set({ count: 0, hasNewMessage: false, isReset: true });
      },

      async fetchUnreadCount() {
        const response = await chat.getUnreadCount();
        const { data } = response.data;
        set((draft) => {
          draft.count = data.count;
          draft.hasNewMessage = data.has_new_message;
          draft.isReset = false;
        });
      },
    })),
    {
      name: 'notifChatCounter',
    },
  ),
);
